export default __webpack_public_path__ + "static/media/excecute_img.a2d2c1d1.png";